/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_ActiveInputs */

const vi_irrigation_schedule_active = /** @type {(inputs: Irrigation_Schedule_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áp dụng lịch này`)
};

/**

* @param {Irrigation_Schedule_ActiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_active = /** @type {((inputs?: Irrigation_Schedule_ActiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_ActiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_active(inputs)
});